import React from "react";
import { Helmet } from "react-helmet";

import GetInfoForm from "../components/getInfoForm";
import Header from "../components/header";
import { Container, Section } from "../components/layout";
import PageIntro from "../components/pageIntro";
import HeaderImage from "../images/header-images/get-info.jpg";
import HeaderMobile from "../images/header-images/get-info-mobile.jpg";

export default function GetInfo() {
  return (
    <div>
      <Helmet htmlAttributes={{lang: 'en'}}>
          <meta charSet="utf-8" />
          <title>Get Information - International Viewbook - Maryville University</title>
      </Helmet>
      <Header image={HeaderImage} mobileImage={HeaderMobile} />
      <Section>
        <Container extraClasses="mb-16">
          <PageIntro
            title="Get Information"
            subtitle="Want to learn more?"
            text="Tell us a bit more about yourself and we'll be in touch with more details about our programs."
          />
        </Container>
        <Container extraClasses="md:px-8">
          <GetInfoForm />
        </Container>
      </Section>
    </div>
  );
}
